import React from 'react';
import PropTypes from 'prop-types';

// Router
import navLinks from '../constants/NavLinks';

// Global style
import GlobalStyle from '../components/Atoms/GlobalStyle';

// Molecules
import Header from '../components/Organisms/Header/Header';
import Footer from '../components/Organisms/Footer/Footer';

const Main = (props) => {
	const { children, isSticky, context } = props;

	return (
		<>
			<GlobalStyle />
			<Header links={navLinks[context]} isSticky={isSticky} />
			<>
				{children}
			</>
			<Footer links={navLinks.footerLinks} />
		</>
	);
};

Main.defaultProps = {
	isSticky: false,
	children: null,
	context: 'headerLinks',
};

Main.propTypes = {
	children: PropTypes.node,
	isSticky: PropTypes.bool,
	context: PropTypes.string,
};
export default Main;
